// const apiUrl = "https://cloudshosting.co.uk/api/v1.0";
const apiUrl = "https://admin.compareairportparkingdeals.co.uk/api/v1.0";
export default apiUrl;
